import useScrollEventListener from '@/hooks/useScrollEventListener';
import Item from '@/models/Item';
import React, { useCallback, useEffect, useRef } from 'react';
import './styles.scss';

interface Props {
    content: Item;
    startLesson: () => void;
    finishLesson: () => void;
}

const ChartPlayer: React.FC<Props> = ({ content, startLesson, finishLesson }) => {
    const finishedRequestSent = useRef<boolean>(false);

    useEffect(startLesson, []);

    const onScroll = useCallback(() => {
        const docElement = window.document.documentElement as HTMLElement;
        const percent = ((docElement.scrollTop + docElement.clientHeight) / docElement.scrollHeight) * 100;

        if (!finishedRequestSent.current && percent === 100) {
            finishedRequestSent.current = true;
            finishLesson();
        }
    }, [finishedRequestSent.current]);

    useScrollEventListener(onScroll);

    return (
        <div className="chart-player-container">
            <img alt="" src={content.path} />
        </div>
    );
};

export default ChartPlayer;
